import React from 'react';
import { withNamespaces } from 'react-i18next';

const Description = () => (
    <div className="card card-bordered">
        <div className="alert alert-info m-b-0">
            <p>
                This is category management. Here you can create, edit and delete custom categories.
            </p>
            <p>
                Please note that you cannot delete predefined categories that come default with Budgetti, but you can hide them.
            </p>
            <p>
                Parent category can only be hidden once all its subcategories are hidden.
            </p>
            <p>
                If you choose to show any of the subcategories, parent category will automatically become visible and available for selection as a category.
            </p>
            <p>
                Scroll to the bottom to see which categories are hidden
            </p>
        </div>
    </div>
);

export default withNamespaces()(Description);


// WEBPACK FOOTER //
// ./src/modules/budget/components/category/description.js